var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _g, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapturePicDt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 131,
    viewBox: "0 0 168 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.468 50.2405H68.6797V26.2933L87.2321 32.365H127.468V50.2405Z",
    fill: "#BF793A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.071 47.9661H54.3672V51.7609H154.071V47.9661Z",
    fill: "#894913"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6861 51.7608H58.6016V66.7717H68.6861V51.7608Z",
    fill: "#D3894C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.841 51.7608H127.469V66.7717H149.841V51.7608Z",
    fill: "#D3894C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.606 65.3552H149.844V66.7718H167.606V65.3552Z",
    fill: "#BF793A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.749 32.5151H87.0602L66.8281 25.8939V23.601L87.4075 30.3362H128.749V32.5151Z",
    fill: "#894913"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4141 32.5151H84.7386L69.4141 27.5V32.5151Z",
    fill: "#FAA64B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.355 33.2756H69.4141V46.9669H126.355V33.2756Z",
    fill: "#FAA64B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8701 33.2756H93.0469V46.9669H93.8701V33.2756Z",
    fill: "#BF793A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8232 54.0877H60.4453V64.3542H66.8232V54.0877Z",
    fill: "#063A4C",
    stroke: "#051B21",
    strokeWidth: 0.817121,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4453 61.2137H66.8232",
    stroke: "#051B21",
    strokeWidth: 0.817121,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.822 75.3414H78.623L69.4141 72.7083H132.613L141.822 75.3414Z",
    fill: "#2A5866",
    stroke: "#051B21",
    strokeWidth: 0.817121,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3438 74.0251H84.1624",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4141 73.6314H96.8968",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6484 74.3752H103.753",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9844 74.0251H85.9853",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.031 74.0251H111.85",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.094 73.6314H124.576",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.648 74.3752H133.753",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.664 74.0251H113.665",
    stroke: "#3A7482",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6653 51.7608H68.6797V69.6388H72.6653V51.7608Z",
    fill: "#BF793A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.47 51.7608H123.484V69.6388H127.47V51.7608Z",
    fill: "#BF793A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M87.8597 51.7606H72.6719V64.6751H87.8597V51.7606Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M78.1076 51.7606H80.8738L78.7272 64.6751H75.9609L78.1076 51.7606Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M81.8498 51.7606H82.891L80.7444 64.6751H79.7031L81.8498 51.7606Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8597 64.6751H72.6719V65.2904H87.8597V64.6751Z",
    fill: "#051B21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4531 58.4536V60.7592",
    stroke: "#051B21",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M123.493 51.7607H108.305V64.6752H123.493V51.7607Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M113.74 51.7607H116.507L114.36 64.6752H111.594L113.74 51.7607Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M117.483 51.7607H118.524L116.377 64.6752H115.336L117.483 51.7607Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M123.493 64.6751H108.305V65.2904H123.493V64.6751Z",
    fill: "#051B21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.086 58.4537V60.7593",
    stroke: "#051B21",
    strokeWidth: 0.544748,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M123.481 65.2909H72.6641V68.5648H123.481V65.2909Z",
    fill: "#FFF1C5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.293 51.7608H87.8516V66.9278H108.293V51.7608Z",
    fill: "#D3894C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6999 54.0877H89.6016V55.7783H94.6999V54.0877Z",
    fill: "#BF793A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1453 56.5278H93.0469V58.2184H98.1453V56.5278Z",
    fill: "#BF793A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M108.291 63.3609H105V65.0515H108.291V63.3609Z",
    fill: "#BF793A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6975 63.3609H91.4062V65.0515H94.6975V63.3609Z",
    fill: "#E2965D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M104.416 54.0877H101.125V55.7783H104.416V54.0877Z",
    fill: "#E2965D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M123.489 51.7606H72.6719V68.5647H123.489V51.7606Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M88.6994 51.7606H92.2987L89.5056 68.5647H85.9062L88.6994 51.7606Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M93.5666 51.7606H94.9215L92.1284 68.5647H90.7734L93.5666 51.7606Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M109.434 51.7606H110.789L107.996 68.5647H106.641L109.434 51.7606Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6953 60.4693V63.4692",
    stroke: "#051B21",
    strokeWidth: 0.708816,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4141 60.4693V63.4692",
    stroke: "#051B21",
    strokeWidth: 0.708816,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M123.489 68.5647H72.6719V69.6385H123.489V68.5647Z",
    fill: "#051B21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8984 51.7606V68.5647",
    stroke: "#051B21",
    strokeWidth: 0.817121,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140 44.1893L139.266 47.8134",
    stroke: "#C97B41",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.414 46.5591L147.597 47.8135",
    stroke: "#C97B41",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138.43 43.5393C139.459 43.598 140.296 44.3664 140.985 45.1332C141.373 45.5648 141.752 46.0162 142.236 46.337C143.088 46.9014 144.171 46.9956 145.189 46.9017C146.206 46.8083 147.202 46.5452 148.221 46.4609C148.563 46.4326 148.937 46.434 149.209 46.6436",
    stroke: "#D3894C",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138.102 44.1893L137.367 47.8134",
    stroke: "#C97B41",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M145.516 46.5591L145.699 47.8135",
    stroke: "#C97B41",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M136.531 43.5393C137.561 43.598 138.397 44.3664 139.087 45.1332C139.475 45.5648 139.854 46.0162 140.338 46.337C141.19 46.9014 142.273 46.9956 143.29 46.9017C144.308 46.8083 145.305 46.5452 146.323 46.4609C146.665 46.4326 147.039 46.434 147.311 46.6436",
    stroke: "#D3894C",
    strokeWidth: 0.356639,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M155.524 61.5418L154.789 65.1659",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M162.938 63.912L163.121 65.166",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M153.953 60.8922C154.983 60.951 155.819 61.7193 156.509 62.4861C156.897 62.9177 157.276 63.3691 157.76 63.6899C158.611 64.2543 159.694 64.3485 160.712 64.2546C161.73 64.1612 162.726 63.8981 163.744 63.8138C164.086 63.7855 164.461 63.7869 164.733 63.9965",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M153.617 61.5418L152.883 65.1659",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M161.031 63.912L161.215 65.166",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M152.047 60.8922C153.076 60.951 153.913 61.7193 154.602 62.4861C154.99 62.9177 155.37 63.3691 155.854 63.6899C156.706 64.2543 157.789 64.3485 158.806 64.2546C159.824 64.1612 160.82 63.8981 161.838 63.8138C162.18 63.7855 162.555 63.7869 162.827 63.9965",
    stroke: "#0E3842",
    strokeWidth: 0.408543,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M130.638 44.3333L130.25 38.7616",
    stroke: "#336633",
    strokeWidth: 0.272374,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.305 44.3333L131.61 37.1814",
    stroke: "#336633",
    strokeWidth: 0.272374,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.883 44.3612L132.77 38.2903",
    stroke: "#336633",
    strokeWidth: 0.272374,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M132.305 44.3333L133.247 39.898",
    stroke: "#336633",
    strokeWidth: 0.272374,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M129.641 40.8961L130.444 44.5829",
    stroke: "#336633",
    strokeWidth: 0.272374,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M132.517 47.9663H130.05L129.735 44.5999C129.717 44.2618 129.985 43.9775 130.324 43.9775H132.243C132.599 43.9775 132.874 44.2912 132.828 44.6445L132.517 47.9663Z",
    fill: "#CCCCCC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M148.596 53.0846H128.703V65.4474H148.596V53.0846Z",
    fill: "#FAA64B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6292 102.443H29.7449C27.0339 102.443 24.8359 100.245 24.8359 97.5337V5.23107C24.8359 2.52008 27.0336 0.322113 29.7449 0.322113H75.6292C78.3402 0.322113 80.5382 2.51972 80.5382 5.23107V97.5337C80.5382 100.245 78.3402 102.443 75.6292 102.443Z",
    fill: "#0C0C0C",
    stroke: "#A3A3A3",
    strokeWidth: 0.540924,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6884 99.3741H30.6756C29.1287 99.3741 27.875 98.12 27.875 96.5735V6.19129C27.875 4.64442 29.1291 3.39072 30.6756 3.39072H74.6884C76.2352 3.39072 77.4889 4.64478 77.4889 6.19129V96.5732C77.4893 98.12 76.2352 99.3741 74.6884 99.3741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4454_55979",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 3,
    width: 51,
    height: 97
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6884 99.3741H30.6756C29.1287 99.3741 27.875 98.1201 27.875 96.5736V6.19135C27.875 4.64448 29.1291 3.39078 30.6756 3.39078H74.6884C76.2352 3.39078 77.4889 4.64484 77.4889 6.19135V96.5732C77.4893 98.1201 76.2352 99.3741 74.6884 99.3741Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4454_55979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.083 -21.8656H27.8828V101.851H157.083V-21.8656Z",
    fill: "#002333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.083 55.2244C156.363 54.5524 155.68 54.7956 155.267 54.9241C153.498 55.4726 152.122 57.1285 150.275 57.2499C147.766 57.4152 146.101 54.8002 144.892 52.5955C142.897 48.9562 140.585 45.4904 137.993 42.249C137.376 41.4782 136.677 40.677 135.719 40.4401C134.94 40.2475 134.115 40.4677 133.381 40.7906C128.886 42.7652 126.322 48.44 121.451 49.056C117.31 49.5797 113.84 46.1461 111.09 43.0056C107.407 38.7987 103.723 34.5915 100.039 30.3843C99.5526 29.8284 99.0201 29.2435 98.3027 29.0661C97.5762 28.8866 96.8224 29.1653 96.1324 29.4549C92.3029 31.0612 88.6746 33.1463 85.3589 35.6466C82.7403 37.6212 80.2761 39.8779 77.29 41.2343C74.3039 42.5907 70.5644 42.882 67.9068 40.9599C66.8546 40.1987 65.8951 39.0795 64.5968 39.0483C63.0011 39.0101 61.8415 40.6458 60.2788 40.9709C58.2961 41.383 56.5693 39.6074 55.4764 37.9026C54.3834 36.1979 53.2324 34.2013 51.2511 33.7821C49.4266 33.3962 47.6557 34.5327 46.1796 35.6728C40.2896 40.221 37.4688 42.4653 27.8828 53.3157V75.5857C51.2564 68.9787 65.4897 76.8284 82.9035 81.3748C95.5546 84.6778 108.559 86.3864 121.523 88.0873C129.453 89.1279 137.387 90.1688 145.36 90.8008C149.303 91.1134 153.417 91.2996 157.062 89.762L157.083 55.2244Z",
    fill: "#001E28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.075 86.8481V101.851H27.875V62.6758C27.875 62.6758 119.203 62.6758 131.92 62.6758C144.637 62.6758 157.075 86.8481 157.075 86.8481Z",
    fill: "#063A4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2623 13.1801C68.2623 13.2934 68.1702 13.3855 68.0569 13.3855C67.9436 13.3855 67.8516 13.2938 67.8516 13.1801C67.8516 13.0668 67.9433 12.9748 68.0569 12.9748C68.1702 12.9748 68.2623 13.0668 68.2623 13.1801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2722 20.4735C46.2722 20.5854 46.1816 20.6761 46.0697 20.6761C45.9578 20.6761 45.8672 20.5854 45.8672 20.4735C45.8672 20.3617 45.9578 20.271 46.0697 20.271C46.1816 20.271 46.2722 20.3617 46.2722 20.4735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7255 37.6232C44.7255 37.7867 44.5927 37.9195 44.4292 37.9195C44.2656 37.9195 44.1328 37.7867 44.1328 37.6232C44.1328 37.4596 44.2656 37.3268 44.4292 37.3268C44.5927 37.3265 44.7255 37.4592 44.7255 37.6232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.375 50.5334H55.9688V28.7782L72.8231 34.294H109.375V50.5334Z",
    fill: "#BF793A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.544 48.4668H42.9688V51.9142H133.544V48.4668Z",
    fill: "#894913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9736 51.9141H46.8125V65.5505H55.9736V51.9141Z",
    fill: "#D3894C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.542 34.4306H72.6691L54.2891 28.4156V26.3327L72.9845 32.4511H110.542V34.4306Z",
    fill: "#894913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6406 34.4306H70.562L56.6406 29.8747V34.4306Z",
    fill: "#FAA64B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.368 35.1214H56.6406V47.5593H108.368V35.1214Z",
    fill: "#FAA64B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2863 54.0282H48.4922V63.3551H54.2863V54.0282Z",
    fill: "#063A4C",
    stroke: "#051B21",
    strokeWidth: 0.74231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4922 60.5017H54.2863",
    stroke: "#051B21",
    strokeWidth: 0.74231,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.419 73.3362H65.0062L56.6406 70.9439H114.054L122.419 73.3362Z",
    fill: "#2A5866",
    stroke: "#051B21",
    strokeWidth: 0.74231,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6562 72.1403H70.0338",
    stroke: "#3A7482",
    strokeWidth: 0.494861,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7031 71.7825H81.5925",
    stroke: "#3A7482",
    strokeWidth: 0.494861,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7891 72.1403H71.6986",
    stroke: "#3A7482",
    strokeWidth: 0.494861,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5893 51.9141H55.9688V68.1553H59.5893V51.9141Z",
    fill: "#BF793A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M73.3909 51.9141H59.5938V63.6464H73.3909V51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M64.5361 51.9141H67.0491L65.099 63.6464H62.5859L64.5361 51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M67.9263 51.9141H68.8724L66.9222 63.6464H65.9766L67.9263 51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3909 63.6463H59.5938V64.2053H73.3909V63.6463Z",
    fill: "#051B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3047 57.9943V60.0889",
    stroke: "#051B21",
    strokeWidth: 0.494861,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.759 64.2055H59.5938V67.1799H105.759V64.2055Z",
    fill: "#FFF1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9608 51.9141H73.3906V65.6928H91.9608V51.9141Z",
    fill: "#D3894C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6161 54.0282H74.9844V55.5641H79.6161V54.0282Z",
    fill: "#BF793A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6072 62.4522H76.6172V63.9881H79.6072V62.4522Z",
    fill: "#E2965D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M105.759 51.9141H59.5938V67.1798H105.759V51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M74.1547 51.9141H77.4244L74.8872 67.1798H71.6172L74.1547 51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M78.5688 51.9141H79.7998L77.2623 67.1798H76.0312L78.5688 51.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5156 59.8255V62.551",
    stroke: "#051B21",
    strokeWidth: 0.643918,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.759 67.1798H59.5938V68.1553H105.759V67.1798Z",
    fill: "#051B21"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M74.5637 99.3741H30.5506C29.0037 99.3741 27.75 98.12 27.75 96.5735V6.19129C27.75 4.64442 29.0041 3.39072 30.5506 3.39072H74.5634C76.1102 3.39072 77.3639 4.64478 77.3639 6.19129V96.5732C77.3643 98.12 76.1106 99.3741 74.5637 99.3741Z",
    fill: "#001E28"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2501 7.65593H41.8624C40.0012 7.65593 38.4922 6.14695 38.4922 4.28569V2.53879H66.6204V4.28569C66.6204 6.14695 65.1114 7.65593 63.2501 7.65593Z",
    fill: "#0C0C0C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1763 5.77531H46.6702C46.2956 5.77531 45.9922 5.47189 45.9922 5.0973C45.9922 4.72271 46.2956 4.41928 46.6702 4.41928H55.1763C55.5509 4.41928 55.8544 4.72271 55.8544 5.0973C55.8544 5.47189 55.5509 5.77531 55.1763 5.77531Z",
    fill: "#353535"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1217 5.0973C59.1217 5.47189 58.8182 5.77531 58.4436 5.77531C58.069 5.77531 57.7656 5.47189 57.7656 5.0973C57.7656 4.72271 58.069 4.41928 58.4436 4.41928C58.8182 4.41928 59.1217 4.72306 59.1217 5.0973Z",
    fill: "#283C5E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7867 32.5251C36.6846 32.5251 33.3594 29.1998 33.3594 25.0981C33.3594 20.996 36.6846 17.6711 40.7864 17.6711C44.8884 17.6711 48.2137 20.9964 48.2137 25.0981C48.2137 29.1998 44.8884 32.5251 40.7867 32.5251Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6923 28.0853C41.6923 28.559 41.3082 28.9431 40.8344 28.9431C40.3607 28.9431 39.9766 28.559 39.9766 28.0853C39.9766 27.6115 40.3607 27.2274 40.8344 27.2274C41.3082 27.2274 41.6923 27.6112 41.6923 28.0853Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0408 26.8871C42.6159 26.1085 41.7903 25.5803 40.8407 25.5803C39.8911 25.5803 39.0655 26.1085 38.6406 26.8871",
    stroke: "white",
    strokeWidth: 0.908751,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5817 25.8158C43.8594 24.4923 42.4556 23.5941 40.8414 23.5941C39.2273 23.5941 37.8235 24.4923 37.1016 25.8158",
    stroke: "white",
    strokeWidth: 0.908751,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0921 24.6768C45.0778 22.8176 43.106 21.5561 40.839 21.5561C38.572 21.5561 36.6003 22.8176 35.5859 24.6768",
    stroke: "white",
    strokeWidth: 0.908751,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8492 61.2746C36.7472 61.2746 33.4219 57.9493 33.4219 53.8476C33.4219 49.7455 36.7472 46.4206 40.8489 46.4206C44.9506 46.4206 48.2759 49.7459 48.2759 53.8476C48.2766 57.9493 44.9513 61.2746 40.8492 61.2746Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8741 54.1349V49.8618C41.8741 49.2964 41.4156 48.8379 40.8502 48.8379C40.2848 48.8379 39.8263 49.2964 39.8263 49.8618V54.1345C38.9719 54.5247 38.375 55.3815 38.375 56.382C38.375 57.7491 39.4832 58.8569 40.8498 58.8569C42.2168 58.8569 43.3247 57.7487 43.3247 56.382C43.3247 55.3818 42.7281 54.525 41.8741 54.1349ZM40.8498 58.2086C39.8411 58.2086 39.0236 57.3911 39.0236 56.3824C39.0236 55.5058 39.6418 54.775 40.4657 54.5983V50.0296C40.4657 49.8175 40.6378 49.6455 40.8498 49.6455C41.0619 49.6455 41.234 49.8175 41.234 50.0296V54.5983C42.0579 54.775 42.6764 55.5058 42.6764 56.3824C42.676 57.3911 41.8585 58.2086 40.8498 58.2086Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5625 56.3824C39.5625 57.0934 40.1389 57.6698 40.8498 57.6698C41.5608 57.6698 42.1372 57.0934 42.1372 56.3824H39.5625Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8492 89.7622C36.7472 89.7622 33.4219 86.4369 33.4219 82.3352C33.4219 78.2331 36.7472 74.9082 40.8492 74.9082C44.9509 74.9082 48.2762 78.2334 48.2762 82.3352C48.2766 86.4369 44.9513 89.7622 40.8492 89.7622Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6685 81.6023H39.0391V79.7878C39.0391 78.7854 39.8516 77.9732 40.8539 77.9732C41.8563 77.9732 42.6685 78.7858 42.6685 79.7878V81.6023Z",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1807 81.1236H38.5182C38.2664 81.1236 38.0625 81.3275 38.0625 81.5792V86.2418C38.0625 86.4935 38.2664 86.6974 38.5182 86.6974H43.1807C43.4324 86.6974 43.6364 86.4935 43.6364 86.2418V81.5792C43.636 81.3275 43.4321 81.1236 43.1807 81.1236ZM40.8493 84.007C40.5533 84.007 40.3132 83.7669 40.3132 83.4709C40.3132 83.175 40.5533 82.9349 40.8493 82.9349C41.1452 82.9349 41.3853 83.175 41.3853 83.4709C41.3853 83.7669 41.1452 84.007 40.8493 84.007Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5914 32.1037C59.4893 32.1037 56.1641 28.7784 56.1641 24.6767C56.1641 20.5746 59.4893 17.2497 63.5911 17.2497C67.6931 17.2497 71.0184 20.575 71.0184 24.6767C71.0184 28.7784 67.6931 32.1037 63.5914 32.1037Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2821 27.4663L58.3047 27.4107L59.9086 21.6223L68.8856 21.6782L67.2821 27.4663Z",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1273 21.6361L60.5234 27.4245",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6426 21.6644L65.0391 27.4525",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4004 21.6502L62.7969 27.4387",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1094 24.5163L68.0864 24.5723",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5995 27.4341H62.4219V29.0121H63.5995V27.4341Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5911 61.2746C59.489 61.2746 56.1641 57.9493 56.1641 53.8476C56.1641 49.7455 59.4893 46.4206 63.5911 46.4206C67.6928 46.4206 71.0181 49.7459 71.0181 53.8476C71.0181 57.9493 67.6928 61.2746 63.5911 61.2746Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8286 53.8855H59.3635C59.2145 53.8855 59.0938 53.7647 59.0938 53.6157V51.2467C59.0938 51.0976 59.2145 50.9769 59.3635 50.9769H67.8286C67.9777 50.9769 68.0984 51.0976 68.0984 51.2467V53.6157C68.0984 53.7647 67.9777 53.8855 67.8286 53.8855Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1875 53.3201C60.1875 55.2023 61.7131 56.7279 63.5953 56.7279C65.4774 56.7279 67.003 55.2023 67.003 53.3201H60.1875Z",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 54.5178C61.5 54.5178 61.888 55.2627 62.8302 55.627",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0133 89.7622C59.9112 89.7622 56.5859 86.4369 56.5859 82.3352C56.5859 78.2331 59.9112 74.9082 64.0133 74.9082C68.1154 74.9082 71.4406 78.2335 71.4406 82.3352C71.4406 86.4369 68.1154 89.7622 64.0133 89.7622Z",
    fill: "white",
    fillOpacity: 0.12,
    stroke: "white",
    strokeWidth: 0.653336,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6201 83.6073C66.6201 85.0448 65.4549 86.2103 64.0171 86.2103C62.5796 86.2103 61.4141 85.0451 61.4141 83.6073C61.4141 81.233 64.0171 78.1676 64.0171 78.1676C64.0171 78.1676 66.6201 81.1841 66.6201 83.6073Z",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5547 84.224C62.5547 84.224 62.868 84.8252 63.6282 85.1194",
    stroke: "white",
    strokeWidth: 0.757286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M24.7969 89.7792V5.36065C24.7969 2.64966 26.9945 0.451691 29.7058 0.451691H75.5902C78.3012 0.451691 80.4991 2.64966 80.4991 5.36065V15.493L24.7969 89.7792Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5637 75.0928V87.3866L19.6498 98.8473L17.9766 95.8007L21.1245 77.6285L24.5637 75.0928Z",
    fill: "#F9BE8A"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M24.628 45.9174L7.69572 69.7919C6.54788 71.4107 5.9952 73.3767 6.13222 75.3566L8.58616 110.821C8.84108 114.505 7.92798 118.174 5.97679 121.309L0 131H33.7654L38.2991 122.783C38.2991 122.783 48.3723 115.127 47.1133 100.248C45.8542 85.3678 40.098 81.7703 40.098 78.3526V58.7327C40.098 55.3051 37.3194 52.5268 33.8922 52.5268C30.4646 52.5268 27.6863 55.3055 27.6863 58.7327V77.6286C27.6863 80.3314 25.5277 84.8283 23.9089 88.0661C22.2898 91.3039 20.6003 94.0021 20.186 97.24C20.1315 97.4198 19.7035 87.6632 24.56 75.0928L24.628 45.9174Z",
    fill: "#FFCC99"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1133 100.248C46.6127 94.3306 45.4004 90.2017 44.1222 87.1547C43.9495 92.0799 43.344 97.0222 41.8591 101.731C40.9609 104.581 39.7376 107.331 38.1302 109.852C36.0172 113.167 33.2857 116.033 30.734 119.023C27.5936 122.703 24.6723 126.672 22.5547 131H33.7658L38.2995 122.783C38.2995 122.783 48.3727 115.127 47.1133 100.248Z",
    fill: "#F9BE8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapturePicDt);
export default __webpack_public_path__ + "static/media/capture_pic_DT.43e401652337a822835436049ae0b3f7.svg";
export { ForwardRef as ReactComponent };